import { ImageParams } from './ImageModel';
import { API_V1 } from '../api';

export type ImageUrl = string & { readonly _: unique symbol };

export interface ImageResult {
	mimeType: string;
	encodedFile: string;
}

export async function getImage(params: ImageParams, headers: Record<string, string>): Promise<ImageResult> {
	const { data } = await API_V1.get('/image/encode', { params, headers, timeout: 0 });
	return data as ImageResult;
}
